"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "renderText", {
    enumerable: true,
    get: ()=>renderText
});
const _react = /*#__PURE__*/ _interopRequireWildcard(require("react"));
const _index = require("./../index");
const _nativeBase = require("native-base");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
const renderText = (props)=>(0, _react.useCallback)(()=>{
        const { t  } = (0, _index.useI18n)();
        const { text , textValues  } = props;
        const str = text && t(text, textValues);
        const elements = [];
        let currentWeight = props.fontWeight || 'normal';
        let currentItalic = false;
        let currentFontSize = props.fontSize || 14;
        const parts = str && str.split(_index.typographyRegex).filter(Boolean);
        if (parts) {
            parts.forEach((part, i)=>{
                switch(part){
                    case '{b}':
                        currentWeight = 'bold';
                        break;
                    case '{/b}':
                        currentWeight = props.fontWeight || 'normal';
                        break;
                    case '{i}':
                        currentItalic = true;
                        break;
                    case '{/i}':
                        currentItalic = false;
                        break;
                    default:
                        if (part.startsWith('{c:')) {
                            const customWeightMatch = part.match(/\{c:(\d+)\}/);
                            if (customWeightMatch) {
                                currentWeight = customWeightMatch[1];
                            }
                        } else if (part.startsWith('{/c:')) {
                            currentWeight = props.fontWeight || 'normal';
                        } else if (part.startsWith('{s:')) {
                            const fontSizeMatch = part.match(/\{s:(\d+)\}/);
                            if (fontSizeMatch) {
                                currentFontSize = parseFloat(fontSizeMatch[1]);
                            }
                        } else if (part.startsWith('{/s:')) {
                            currentFontSize = props.fontSize || 14; // Default font size if not specified
                        } else {
                            elements.push(/*#__PURE__*/ _react.default.createElement(_nativeBase.Text, _extends({
                                key: i
                            }, props, {
                                fontWeight: currentWeight,
                                fontStyle: currentItalic ? 'italic' : 'normal',
                                fontSize: currentFontSize
                            }), part));
                        }
                        break;
                }
            });
        }
        return elements;
    }, [
        props.text,
        props.textValues
    ])();
